import { appConfigs } from '../../../config';
import { FunctionComponent } from 'react';
import { RouteComponentProps, Route as RouteDom } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { RouteProps } from '../route/Route.props';

export const Route: FunctionComponent<RouteProps> = (props: RouteProps) => {
  const { path, component, title, meta, exact, canActivates } = props;
  const Component = component as FunctionComponent<RouteProps>;
  const metaData = meta || [];

  if (!canActivates || canActivates?.every((guard) => new guard().canActivate() == true)) {
    return (
      <RouteDom
        path={path}
        exact={exact}
        render={(props: RouteComponentProps) => {
          return (
            <>
              <Helmet>
                <title>{title || appConfigs['APP_NAME']}</title>

                {!metaData.find((metaItem) => metaItem.name.toLowerCase() === 'description') && (
                  <meta name="description" content={appConfigs['APP_DESCRIPTION']} />
                )}

                {metaData.map(({ name, content }) => (
                  <meta key={name} name={name} content={content} />
                ))}
              </Helmet>

              <Component {...props} />
            </>
          );
        }}
      />
    );
  }

  return null;
};
